
export default {
  props: {
    orders: {
      type: [Array, null],
      default: () => [],
    },
  },
  data() {
    return {
      showAllOrders: false,
    }
  },
  computed: {
    firstOrders() {
      return this.orders?.slice(0, 3) || []
    },
    remainingOrders() {
      return this.orders?.slice(3) || []
    },
    showButton() {
      return this.remainingOrders.length > 0
    },
    buttonText() {
      return this.showAllOrders
        ? this.$gettext('Close')
        : this.$gettext('Show more')
    },
  },
  methods: {
    toggleAllOrders() {
      this.showAllOrders = !this.showAllOrders
    },
  },
}
